<div class="grid-x grid-margin-x">

  <div class="cell small-12">
    <button (click)="close()" class="button">Back</button>
    @if (canManageComunnications) {
      <button [disabled]="!validDocumentTypeSelected()" (click)="save()" class="button">Save</button>
    }
  </div>

  <div class="cell medium-4">
    <label for="nameInput">Name:</label>
    <input type="text" id="nameInput" placeholder="Enter Name" [(ngModel)]="template.name" />
  </div>
  <!--<div class="cell medium-4">
  <label for="idInput">Flow Template ID:</label>
  <input type="text" id="idInput" placeholder="Enter Flow Template ID" [(ngModel)]="template.reportFlowId" />
</div>-->
<div class="cell medium-4">
  <label for="idID">This Template ID:</label>
  <input [disabled]="true" type="text" id="idID" [(ngModel)]="template.id" />
</div>

<div class="cell medium-6">
  <label>
    <span>Type</span>
    <select (change)="typeChanged($event.target.value)">
      @for (type of types; track type) {
        <option [value]="type.Code"
          [selected]="template.typeCode?.toLowerCase() == type.Code.toLowerCase()">
          {{type.Definition}}
        </option>
      }
    </select>
  </label>
</div>

<div class="cell medium-6">
  <label>
    <span>Category</span>
    <select (change)="catChanged($event.target.value)">
      @for (cat of cats; track cat) {
        <option [value]="cat.Code"
          [selected]="template.categoryCode == cat.Code">
          {{cat.Definition}}
        </option>
      }
    </select>
  </label>
</div>

<div class="cell large-12 margin-right">
  <div class="bold">
    *Document Group:
  </div>
  <div>
    @if (documentGroups.length !== 1) {
      <ng-select  [(ngModel)]="template.onBaseDocumentGroupName" [items]="documentGroups" bindLabel="name" bindValue="name" placeholder=""
      (change)="docGroupSelected($event)"></ng-select>
    }
  </div>
  <div>
    <text-loader [run]="documentGroups.length === 1" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
  </div>
</div>
<div class="cell large-12">
  <div class="bold">
    *Document Type:
  </div>
  @if (!loadingDocTypes) {
    <ng-select [(ngModel)]="template.onBaseDocumentTypeName" [items]="filteredDocTypes()" bindLabel="name" bindValue="name" placeholder=""
    (change)="docTypeSelected($event)"></ng-select>
  }
  @if ((!this.selectedDocumentType || this.selectedDocumentType.id == -1) && !loadingDocTypes) {
    <div class="error-container">
      @if (!validDocumentTypeSelected()) {
        <small class="error">
          Please select a valid document group and type.
        </small>
      }
    </div>
  }
  <text-loader [run]="loadingDocTypes" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="2000"></text-loader>
</div>

@if (type == communicationTypes.ChiefOrder) {
  <div class="cell small-12">
    <h3>Authority to Sign Chief Order</h3>
  </div>
  <div class="cell small-4">
    <label for="signerTypeDeputy">Deputy</label>
    <input class="no-margin vertical-align-middle" type="checkbox" id="signerTypeDeputy" name="signerTypeDeputy"
      (change)="signerTypeClick($event.target.checked, signerTypes.Deputy)" [checked]="template.allowedSignerTypes.includes('Deputy')" />
    </div>
    <div class="cell small-4">
      <label for="signerTypeAssistant">Assistant</label>
      <input class="no-margin vertical-align-middle" type="checkbox" id="signerTypeAssistant" name="signerTypeAssistant"
        (change)="signerTypeClick($event.target.checked, signerTypes.Assistant)" [checked]="template.allowedSignerTypes.includes('Assistant Chief')" />
      </div>
      <div class="cell small-4">
        <label for="signerTypeChief">Chief</label>
        <input class="no-margin vertical-align-middle" type="checkbox" id="signerTypeChief" name="signerTypeChief"
          (change)="signerTypeClick($event.target.checked, signerTypes.Chief)" [checked]="template.allowedSignerTypes.includes('Chief')" />
        </div>
        <div class="cell small-12">
          <h3>Applicable Post Issuance Steps</h3>
        </div>
        <div class="cell small-6">
          <label for="appeal">Appeal</label>
          <input class="no-margin vertical-align-middle" type="checkbox" id="appeal" name="appeal" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Appeal)"
            [checked]="isPostIssueOptionEnabled(postIssueOptions.Appeal)"/>
          </div>
          <div class="cell small-6">
            <label for="modify">Modify</label>
            <input class="no-margin vertical-align-middle" type="checkbox" id="modify" name="modify" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Modify)"
              [checked]="isPostIssueOptionEnabled(postIssueOptions.Modify)" />
            </div>
            <div class="cell small-6">
              <label for="vacate">Vacate</label>
              <input class="no-margin vertical-align-middle" type="checkbox" id="vacate" name="vacate" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Vacate)"
                [checked]="isPostIssueOptionEnabled(postIssueOptions.Vacate)"/>
              </div>
              <div class="cell small-6">
                <label for="suspend">Suspend</label>
                <input class="no-margin vertical-align-middle" type="checkbox" id="suspend" name="suspend" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Suspend)"
                  [checked]="isPostIssueOptionEnabled(postIssueOptions.Suspend)"/>
                </div>
                <div class="cell small-6">
                  <label for="revoke">Revoke</label>
                  <input class="no-margin vertical-align-middle" type="checkbox" id="revoke" name="revoke" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Revoke)"
                    [checked]="isPostIssueOptionEnabled(postIssueOptions.Revoke)"/>
                  </div>
                  <div class="cell small-6">
                    <label for="terminate">Terminate</label>
                    <input class="no-margin vertical-align-middle" type="checkbox" id="terminate" name="terminate" (change)="postIssueOptionClick($event.target.checked, postIssueOptions.Terminate)"
                      [checked]="isPostIssueOptionEnabled(postIssueOptions.Terminate)"/>
                    </div>
                  }
                  <div class="cell small-22">
                    <button (click)="showLetterEditor()" class="button">Show Letter</button>
                    @if (showHideLetterEditor) {
                      <div>
                        <h3>Header Editor</h3>
                        <div class="checkbox cell small-4">
                          <input class="show-for-sr" id="pageNumberHeader" type="checkbox" name="pageNumberHeader" [(ngModel)]="letterContentModel.usePageNumberHeader" />
                          <label for="pageNumberHeader">
                            Append page number header to edited header: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                          </label>
                        </div>
                        <div [froalaEditor]="froalaOptions" [(ngModel)]="letterContentModel.htmlHeader"></div>
                        <h3>Main Content Editor</h3>
                        <div [froalaEditor]="froalaOptions" [(ngModel)]="letterContentModel.htmlContent"></div>
                        <h3>Footer Content Editor</h3>
                        <div [froalaEditor]="froalaOptions" [(ngModel)]="letterContentModel.htmlFooter"></div>
                        <br />
                        @if (canManageComunnications) {
                          <button (click)="saveContent()" class="button">Save</button>
                          } &nbsp; &nbsp;  <button (click)="hide()" class="button">Hide Letter</button>
                        </div>
                      }
                    </div>
                    <div class="cell small-12">
                      <h3>Values</h3>
                      <p>
                        INFO: All the fields disabled in the list below are automatically populated by the system when generating the letter, and the targets are the ones to be used if trying to insert into template content.  For use in the letter content, use the provided target text in brackets, such as [exampleTextToReplace].
                      </p>
                    </div>
                    @if (this.template.typeCode.toLowerCase() != 'reminder') {
                      <div class="cell small-22">
                        <button (click)="addValue()" class="button">Add new merge field</button>
                      </div>
                    }
                    <div class="grid-x grid-padding-x align-bottom">
                      @for (pair of template.reportContextValues; track pair; let i = $index) {
                        <div class="cell small-3">
                          <label [for]="'valueName' + i">Name:</label>
                          <input type="text" [disabled]="pair.systemProvided" [id]="'valueName' + i" placeholder="Enter Name" [(ngModel)]="pair.displayName" />
                        </div>
                        <div class="cell small-3">
                          <label [for]="'valueTarget' + i">Target:</label>
                          <input type="text" [disabled]="pair.systemProvided" [id]="'valueTarget' + i" placeholder="Enter Value" [(ngModel)]="pair.contextValue" />
                        </div>
                        <div class="cell small-4">
                          <label [for]="'valueName' + i">
                            Keyword Type:
                            @if (!loadingKeywordMappings) {
                              <ng-select [disabled]="pair.systemProvided" [(ngModel)]="pair.onBaseKeywordName" [items]="mappedKeyWords" bindLabel="name" bindValue="name" placeholder=""></ng-select>
                            }
                            <text-loader [run]="loadingKeywordMappings" [text]="'Loading Keywords'" [tickType]="'.'" [interval]="2000"></text-loader>
                          </label>
                        </div>
                        @if (!pair.systemProvided) {
                          <div class="cell small-2">
                            <!--<button class="button" (click)="movePair('up', i)">&#8593;</button>
                            <button [disabled]="template.reportContextValues[i+1].systemProvided" class="button" (click)="movePair('down', i)">&#8595;</button>-->
                            <button (click)="removeValue(i)" class="button">Remove</button>
                          </div>
                        }
                      }
                    </div>
                  </div>